// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"171":"81e445cedb1aa686","1821":"e0160c69a4885bd2","8154":"79c82bf3777828a0"}[chunkId] + ".css";
};